export var EJointCapable;
(function (EJointCapable) {
    EJointCapable[EJointCapable["Joint_Anchor"] = 0] = "Joint_Anchor";
    EJointCapable[EJointCapable["Joint_ConnectAnchor"] = 1] = "Joint_ConnectAnchor";
})(EJointCapable || (EJointCapable = {}));
